// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__E1xXL","secondary":"button_secondary__-pmsK","ghost":"button_ghost__OusyD","isLoading":"button_isLoading__+EKH-","disabled":"button_disabled__GyqFf"};